import Vue from "vue";
import Help from "@/utils/helper";
import AxiosPlugin from "@/plugins/axios";
window.Help = Help;
import vuetify from "@/plugins/vuetify";
import print from "@/plugins/print";
import i18n from "@/plugins/i18n";
import router from "@/router";
import store from "@/stores";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import VueMeta from "vue-meta";
import App from "@/App.vue";
import { keepAliveRefreshMixin } from "@/utils/keepAlive";
// Import global font styles
import "@/assets/css/fonts.css";
import "@/assets/css/scan-qr-theme.css";
// PosSmart v2 brutal design layer (landing / auth / faq / contact)
import "@/styles/possmart-brutal.css";
// layout
import Default from "@/layouts/default";
import basic from "@/layouts/basic";
import admin from "@/layouts/admin";
import blank from "@/layouts/blank";
import product from "@/layouts/product";
import online from "@/layouts/online";

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import VueApexCharts from "vue-apexcharts";
import AppLoading from "@/components/AppLoading";
import TextSearch from "@/components/global/TextSearch";
import KpiCards from "@/components/global/KpiCards";
import AppCustomDialog from "@/components/customDialog";
import AppImg from "@/components/img";
import DatePicker from "@/components/global/DatePicker";
import LanguageFlag from "@/components/global/LanguageFlag.vue";
import VueMasonry from "vue-masonry-css";
import { myMixin } from "@/mixin/main";
import { createPinia, PiniaVuePlugin } from "pinia";
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// Register common filters globally so any component template can use | moment, | ToNumber, etc.
if (myMixin && myMixin.filters) {
  Object.keys(myMixin.filters).forEach((key) => {
    Vue.filter(key, myMixin.filters[key]);
  });
}

/* --------------------------------- Module --------------------------------- */
Vue.use(VueMasonry);
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.component("AppLoading", AppLoading);
Vue.component("TextSearch", TextSearch);
Vue.component("KpiCards", KpiCards);
Vue.mixin(keepAliveRefreshMixin);
Vue.component("AppCustomDialog", AppCustomDialog);
Vue.component("AppImg", AppImg);
Vue.component("DatePicker", DatePicker);
Vue.component("LanguageFlag", LanguageFlag);
Vue.use(VueToast, { position: "top-right" });
Vue.use(AxiosPlugin);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueMeta);
/* --------------------------------- Layout --------------------------------- */
Vue.component("default", Default);
Vue.component("basic", basic);
Vue.component("admin", admin);
Vue.component("blank", blank);
Vue.component("product", product);
Vue.component("online", online);

/* --------------------------------- Config --------------------------------- */
Vue.config.productionTip = false;
const app = new Vue({
  vuetify,
  el: "#app",
  pinia,
  store,
  i18n,
  router,
  render: (h) => h(App),
});
export default app;

// Apply locale-driven font class and lang attribute on html element
function applyFontClass(locale) {
  const root = document.documentElement;
  const cls =
    locale === "th"
      ? "font-th"
      : locale === "la"
      ? "font-la"
      : locale === "ch"
      ? "font-ch"
      : "font-en";

  // Map locale to lang attribute
  const localeToLang = {
    en: "en",
    th: "th",
    la: "la",
    ch: "zh", // Chinese uses "zh" as standard HTML lang code
  };
  const lang = localeToLang[locale] || "en";

  // Remove existing locale classes
  root.classList.remove("font-en", "font-th", "font-la", "font-ch");
  // Add current locale class
  root.classList.add(cls);
  // Set lang attribute to match locale
  root.setAttribute("lang", lang);
}
// Initial apply
applyFontClass(i18n.locale);
// React to locale changes
app.$watch(
  () => i18n.locale,
  (newLocale) => applyFontClass(newLocale)
);

// Ensure our font override rules load after Vuetify CSS by injecting a runtime <style> tag
(function injectFontOverrides() {
  const css = `
  .v-application .text-h1,
  .v-application .text-h2,
  .v-application .text-h3,
  .v-application .text-h4,
  .v-application .text-h5,
  .v-application .text-h6,
  .v-application .text-subtitle-1,
  .v-application .text-subtitle-2,
  .v-application .text-body-1,
  .v-application .text-body-2,
  .v-application .text-button,
  .v-application .text-caption,
  .v-application .text-overline,
  .v-application .title,
  .v-application .headline,
  .v-application .subtitle-1,
  .v-application .subtitle-2,
  .v-application .body-1,
  .v-application .body-2,
  .v-application .caption,
  .v-application .overline,
  .v-application .v-card__title,
  .v-application .v-card__text,
  .v-application .v-list-item__title,
  .v-application .v-list-item__subtitle,
  .v-application .v-toolbar__title,
  .v-application .v-btn,
  .v-application .v-chip,
  .v-application .v-alert,
  .v-application .v-snackbar__content,
  .v-application .v-dialog .v-card__title,
  .v-application .v-menu .v-list-item,
  .v-application .v-data-table th,
  .v-application .v-data-table td,
  .v-application .v-text-field input,
  .v-application .v-textarea textarea,
  .v-application .v-select .v-select__selection,
  .v-application .v-autocomplete input,
  .v-application .v-combobox input {
    font-family: var(--app-font) !important;
  }`;
  const style = document.createElement("style");
  style.type = "text/css";
  style.setAttribute("data-font-overrides", "true");
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
})();
